import React, { useEffect, useState } from "react";
import BarraDePasos from "./BarraDePasos";
import Login from "../Login";
import CargaPasajeros from "./CargaPasajeros";
import FichaReserva from "./FichaReserva";
import Pago from "./Pago";
import Finalizacion from "./Finalizacion";
import {
  stockEnDemanda,
  calcularFamilyPlan,
  manejadorDeRespuesta,
  despejarInfoas,
  getTarifaBase,
  calcularImpuestosPais,
} from "../../utils/Tools";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { chartersAPI, productosAPI, toolsAPI } from "../../utils/funcionesAPI";
// import LoaderFormal from "../Global/LoaderFormal";

const ProcesoCompra = (props) => {
  const [paso, setPaso] = useState(1);
  const [numeroReserva, setNumeroReserva] = useState(0);
  const [medioPago, setMedioPago] = useState(0);
  const [estado, setEstado] = useState("");
  const [producto] = useState(JSON.parse(sessionStorage.getItem("producto")));
  const [charter] = useState(JSON.parse(sessionStorage.getItem("charter")));
  const [infoas, setInfoas] = useState(0);
  // const [totalTasasDeInfoas, setTotalTasasDeInfoas] = useState(0);
  const [pasajerosPagantes, setPasajerosPagantes] = useState(0);
  const [tarifaNeta, setTarifaNeta] = useState(0);
  const [cargosAdministrativos, setCargosAdministrativos] = useState(0);
  const [impuestos, setImpuestos] = useState(0);
  const [impuestoPais, setImpuestoPais] = useState(0);
  const [totalPaquete, setTotalPaquete] = useState(0);
  const [totalPorPersona, setTotalPorPersona] = useState(0);
  const [totalPaqueteConPlanFamily, setTotalPaqueteConPlanFamily] = useState(0);
  const [puntosDeEmbarques, setPuntosDeEmbarques] = useState([]);
  const [, setIncluirSeguroDeCancelacion] = useState(
    false
  );
  const [totalSeguroCancelacion, setTotalSeguroCancelacion] = useState(0);

  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");
  const tipoCliente = sessionStorage.getItem("tipoCliente") || 'IND';
  const tarifaPorHabitacion = producto && producto.tarifaPorHabitacion === '1';
/*
  if (!token && !user) {
    props.history.push("/paquete-turistico/proceso-compra/login/");
    return null;
  }
*/
  const { busqueda, pasajerosAdultos, pasajerosMenores } = props;
  
  const traerGastosDeReservaDeSalida = () => {
    if (!producto || !charter) {
      return;
    }

    if (producto.aplicaGastosReservaGenerico === 1) {
      const data = JSON.stringify({
        peticion: "traerGastosDeReservaDelDia",
        codigoMoneda: producto.moneda.codigoMoneda,
        fechaSalida: charter.fechaSalida,
      });
      productosAPI(data).then((respuesta) => {
        if (respuesta) {
          if (respuesta.aplica) {
            producto.gastoDeReserva = respuesta;
            sessionStorage.setItem("producto", JSON.stringify(producto));
            calcularTotales();
          }
        }
      });
    }
  };

  const calcularSeguroDeCancelacion = (tarifaBase) => {
    //const { totalPaquete, cargosAdministrativos, totalSeguroCancelacion } = this.state;
    const data = JSON.stringify({
      accion: "calcularSeguroDeCancelacion",
      totalPaquete: tarifaBase
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setTotalPaquete(parseFloat(totalPaquete) + parseFloat(respuesta.data));
        setIncluirSeguroDeCancelacion(true);
        setTotalSeguroCancelacion(respuesta.data);
      }
    });
  };

  const traerPuntosDeEmbarquePorIdCharter = (idCharter, origen) => {
    const data = JSON.stringify({
      peticion: "traerPuntosDeEmbarque",
      idCharter,
      origen
    });
    chartersAPI(data).then((respuesta) => {
      if (respuesta) {
        setPuntosDeEmbarques(respuesta);
      }
    });
  };

  const calcularTotalPasajerosPagantes = () => {
    const localInfoas = despejarInfoas(pasajerosMenores); //function en Tools
    return pasajerosAdultos.length + pasajerosMenores.length - localInfoas;
  }

  const calcularTotalesDePaquetesPorHabitacion = (prod, char, menores, busq, tipCli, token) => {
    const data = JSON.stringify({
      accion: "calcularTotalesDePagoParaHabitacion",
      producto: prod,
      charter: char,
      pasajerosMenores: menores,
      origen: char.cabecera,
      tipoCliente: tipCli,
      token
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setInfoas(respuesta.data.menoresInfoas);
        // setTotalTasasDeInfoas(tasasDeInfoas);
        setPasajerosPagantes(respuesta.data.pasajerosPagantes);
        setTarifaNeta(respuesta.data.tarifaNeta);
        setCargosAdministrativos(respuesta.data.cargosAdministrativos);
        setImpuestos(respuesta.data.impuestosLocales);
        //setImpuestoPais(impuestoPaisLocal);
        setTotalPaquete(respuesta.data.totalPaquete);
        setTotalPorPersona(respuesta.data.totalPorPersona);
        setTotalPaqueteConPlanFamily(respuesta.data.totalPaqueteConPlanFamily);
      }
    });
  }

  const calcularTotales = () => {
    const { pasajerosAdultos, pasajerosMenores } = props;
    if (!producto || !charter) {
      return;
    }
    if (tarifaPorHabitacion) {
      calcularTotalesDePaquetesPorHabitacion(producto, charter, pasajerosMenores, busqueda, tipoCliente, token);
      return;
    }

    producto.charters = [];
    //FC: calculos del total de la reserva
    //const totalPlanFamilyNeto = calcularFamilyPlanNeto(producto, charter, pasajerosAdultos, pasajerosMenores);
    const localInfoas = despejarInfoas(pasajerosMenores); //function en Tools
    const cantidadPasajerosPagantes = calcularTotalPasajerosPagantes();

   // const impuestoPaisLocal = calcularImpuestosPais(producto.idProducto, charter, cantidadPasajerosPagantes, busqueda.origen, tipoCliente);//} 0;
/*     if (producto.impuestoPAIS.coeficiente > 0) {
      impuestoPaisLocal =
        (charter.tarifa.tarifa -
          charter.tarifa.importeNoComisionable -
          charter.tarifa.tarifa * (charter.promoValijaYa / 100)) *
        producto.impuestoPAIS.coeficiente *
        (producto.impuestoPAIS.valor / 100) *
        cantidadPasajerosPagantes *
        producto.moneda.cotizacion;
    } */

    const tasasDeInfoas = localInfoas * producto.importeDeInfoa;

    //FC: descomentar cuando este en pesos
    /*
    const tarifaNetaLocal = Math.round(
      (charter.tarifa.tarifaNeta -
        charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100)) *
        cantidadPasajerosPagantes *
        producto.moneda.cotizacion
    ).toLocaleString();
    */
    const tarifaNetaLocal = Math.ceil(
      (charter.tarifa.tarifaNeta -
        charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100)) *
        cantidadPasajerosPagantes
    );
    
    //FC: descomentar cuando este en pesos
    /*
    const cargosAdministrativosLocal = Math.round(
      producto.gastoDeReserva.importe *
        cantidadPasajerosPagantes *
        producto.moneda.cotizacion
    );
    */
    const cargosAdministrativosLocal = Math.ceil(
      producto.gastoDeReserva.importe *
        cantidadPasajerosPagantes
    );

    //FC: descomentar cuando este en pesos
    /*
    const impuestosLocal = Math.round(
      (charter.tarifa.tarifa -
        charter.tarifa.tarifa * (charter.promoValijaYa / 100) -
        (charter.tarifa.tarifaNeta -
          charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100)) +
        charter.tarifa.importeNoComisionable * (charter.promoValijaYa / 100)) *
        cantidadPasajerosPagantes *
        producto.moneda.cotizacion +
        tasasDeInfoas +
        impuestoPaisLocal
    );
    */
    const impuestosLocal = Math.ceil(
      (charter.tarifa.tarifa -
        charter.tarifa.tarifa * (charter.promoValijaYa / 100) -
        (charter.tarifa.tarifaNeta -
          charter.tarifa.tarifaNeta * (charter.promoValijaYa / 100)) +
        charter.tarifa.importeNoComisionable * (charter.promoValijaYa / 100)) *
        cantidadPasajerosPagantes +
        tasasDeInfoas +
        impuestoPais,
    );

    //FC: descomentar cuando este en pesos
    /*
    const totalPaqueteLocal = Math.round(
      (charter.tarifa.tarifa -
        charter.tarifa.tarifa * (charter.promoValijaYa / 100) +
        producto.gastoDeReserva.importe +
        charter.tarifa.importeNoComisionable * (charter.promoValijaYa / 100)) *
        cantidadPasajerosPagantes *
        producto.moneda.cotizacion +
        tasasDeInfoas +
        impuestoPaisLocal
    )
      .toFixed(2)
      .toLocaleString();
    */
    const totalPaqueteLocal = Math.ceil(
      (charter.tarifa.tarifa -
        charter.tarifa.tarifa * (charter.promoValijaYa / 100) +
        producto.gastoDeReserva.importe +
        charter.tarifa.importeNoComisionable * (charter.promoValijaYa / 100)) *
        cantidadPasajerosPagantes +
        tasasDeInfoas +
        impuestoPais, 2
    );
     
   
    const totalPaqueteConPlanFamilyLocal = calcularFamilyPlan(
      producto,
      charter,
      pasajerosAdultos,
      pasajerosMenores
    );

    setInfoas(localInfoas);
    // setTotalTasasDeInfoas(tasasDeInfoas);
    setPasajerosPagantes(cantidadPasajerosPagantes);
    setTarifaNeta(tarifaNetaLocal);
    setCargosAdministrativos(cargosAdministrativosLocal);
    setImpuestos(impuestosLocal);
    //setImpuestoPais(impuestoPaisLocal);
    setTotalPaquete(totalPaqueteLocal);
    setTotalPaqueteConPlanFamily(totalPaqueteConPlanFamilyLocal);

  };

  useEffect(() => {
    if (props.match.params.numeroReserva && props.match.params.estado) {
      setPaso(4);
      setNumeroReserva(props.match.params.numeroReserva);
      setMedioPago(3);
      setEstado(props.match.params.estado);
      props.history.push(
        `/paquete-turistico/proceso-compra/finalizacion/${props.match.params.estado}/${props.match.params.numeroReserva}`
      );
      //FC: script de Google Tag Manager para AVALON
      const gtag = window.gtag;
      gtag("event", "conversion", {
        send_to: "AW-783256938/C4e2CM-UzY8BEOqavvUC",
        transaction_id: "",
      });
    } else {
      if (!token && !user) {
        setPaso(1);
      } else {
        setPaso(2);
        props.history.push("/paquete-turistico/proceso-compra/carga-pasajeros/");
        stockEnDemanda(1);
      }

      calcularTotales();
      !tarifaPorHabitacion && traerGastosDeReservaDeSalida();
      const tarifaBase = getTarifaBase(charter);
      !tarifaPorHabitacion && calcularImpuestosPais(producto.idProducto, charter, calcularTotalPasajerosPagantes(),  charter.cabecera, tipoCliente, tarifaBase, setImpuestoPais, props);
      charter && traerPuntosDeEmbarquePorIdCharter(charter.idCharter, charter.cabecera);
    }
   
  }, [
    producto,
    charter,
    busqueda.origen,
    props.match.params.numeroReserva,
    props.match.params.estado,
    tipoCliente,
    impuestoPais
  ]);

  const handleRecalcularTotalesCuandoEsTarjetaConImpuestoPais = () => {
    const { pasajerosAdultos, pasajerosMenores } = props;

    //FC: calculos del total de la reserva
    //const totalPlanFamilyNeto = calcularFamilyPlanNeto(producto, charter, pasajerosAdultos, pasajerosMenores);
    const infoasLocal = despejarInfoas(pasajerosMenores); //function en Tools
    const pasajerosPagantesLocal =
      pasajerosAdultos.length + pasajerosMenores.length - infoasLocal;

    let impuestoPaisLocal = 0;
    if (producto.impuestoPAIS.coeficiente === 0) {
      //como para que zafe pusieron el coeficiente en 0 cuando debe aplicar a todo el prodcuto, es decir VALE 1 (es el 1 entero que se ve en la formula)
      impuestoPaisLocal =
        (charter.tarifa.tarifa -
          charter.tarifa.importeNoComisionable -
          charter.tarifa.tarifa * (charter.promoValijaYa / 100)) *
        1 *
        (producto.impuestoPAIS.valor / 100) *
        pasajerosPagantesLocal *
        producto.moneda.cotizacion;
    }

    const impuestosLocal = parseFloat(this.state.impuestos) + impuestoPaisLocal;
    const totalPaqueteLocal =
      parseFloat(this.state.totalPaquete) + impuestoPaisLocal; //Math.round(((((charter.tarifa.tarifa - (charter.tarifa.tarifa * (charter.promoValijaYa / 100)) + producto.gastoDeReserva.importe)) + (charter.tarifa.importeNoComisionable * (charter.promoValijaYa / 100))) * pasajerosPagantes * producto.moneda.cotizacion) + totalTasasDeInfoas + impuestoPais).toFixed(2).toLocaleString();

    setImpuestos(impuestosLocal);
    setImpuestoPais(impuestoPaisLocal);
    setTotalPaquete(totalPaqueteLocal);
    //this.setState({impuestos, impuestoPais, totalPaquete});
  };

  const handleIncluirSeguroDeCancelacionClick = (e) => {
    const target = e.target;
    if (target.checked === true) {  
      tarifaPorHabitacion ? 
        calcularSeguroDeCancelacion(totalPorPersona * calcularTotalPasajerosPagantes()) : 
        calcularSeguroDeCancelacion(charter.tarifa.tarifa * calcularTotalPasajerosPagantes());
      //nuevoTotal = totalPaquete + totalSeguroCancelacion;
    } else {
      const nuevoTotal = parseFloat(totalPaquete) - totalSeguroCancelacion;
      setTotalPaquete(nuevoTotal);
      setIncluirSeguroDeCancelacion(false);
      setTotalSeguroCancelacion(0);
    }
  };

  const handlePasajeroAdultoChange = (indice, propiedad, valor) => {
    props.onPasajeroAdultoChange(indice, propiedad, valor);
  };

  const handlePasajeroMenorChange = (indice, propiedad, valor) => {
    props.onPasajeroMenorChange(indice, propiedad, valor);
  };

  const handlePasoPagarClick = (e) => {
    setPaso(3);
    props.history.push("/paquete-turistico/proceso-compra/pago/");
  };

  const handleLoginEnCompraClick = (estado) => {
    if (estado) {
      setPaso(2);
      props.history.push("/paquete-turistico/proceso-compra/carga-pasajeros/");
    }
  };

  //FC: entro aca si decidi pagar con deposito o efectivo, si fue con MercadoPago lo resolvi en el didMount
  const handleReservarClick = (numeroReserva, medioDePago) => {
    setPaso(4);
    setNumeroReserva(numeroReserva);
    setMedioPago(medioDePago);
    props.history.push("/paquete-turistico/proceso-compra/finalizacion/");
    //FC: script de Google Tag Manager para AVALON
    const gtag = window.gtag;
    gtag("event", "conversion", {
      send_to: "AW-783256938/C4e2CM-UzY8BEOqavvUC",
      transaction_id: "",
    });
  };
  /*
  const handleVolverClick = (e) => {
    props.history.goBack();
  };
  */
  const handleLoginClick = (e) => {
    props.onLoginClick();
  };



  return (
    <section className="checkout-steps">
      <div className="container">
        <div className="row">
          <div className="content col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12">
            <BarraDePasos paso={paso} />
            {paso === 1 && (
              <Login
                onLoginClick={handleLoginClick}
                mostrarToastContainer={false}
                onLoginClickEnCompra={handleLoginEnCompraClick}
              />
            )}
            {paso === 2 && (
              <CargaPasajeros
                pasajerosAdultos={pasajerosAdultos}
                pasajerosMenores={pasajerosMenores}
                producto={producto}
                charter={charter}
                busqueda={busqueda}
                onPasajeroAdultoChange={handlePasajeroAdultoChange}
                onPasajeroMenorChange={handlePasajeroMenorChange}
                onPasoPagarClick={handlePasoPagarClick}
              />
            )}

            {paso === 3 && (
              <Pago
                pasajerosAdultos={pasajerosAdultos}
                pasajerosMenores={pasajerosMenores}
                producto={producto}
                charter={charter}
                cabecera={producto.cabecera || 'CENT'}
                puntosDeEmbarques={puntosDeEmbarques}
                totalPaquete={totalPaquete}
                totalPaqueteConPlanFamily={totalPaqueteConPlanFamily}
                tarifaNeta={tarifaNeta}
                impuestoPais={impuestoPais}
                cargosAdministrativos={cargosAdministrativos}
                onReservarClick={handleReservarClick}
                totalSeguroCancelacion={totalSeguroCancelacion}
                onClickPagoConTarjetaConImpuesto={
                  handleRecalcularTotalesCuandoEsTarjetaConImpuestoPais
                }
                onClickPagoEfvoDepoConImpuesto={calcularTotales}
                onClickIncluirSeguroDeCancelacion={
                  handleIncluirSeguroDeCancelacionClick
                }
              />
            )}

            {paso === 4 && (
              <Finalizacion
                medioDePago={medioPago}
                numeroReserva={numeroReserva}
                estado={estado}
              />
            )}
            <div className="listado">
              <Link to="/" onClick={() => props.history.goBack()}>
                Volver al listado
              </Link>
            </div>
          </div>

          {!props.match.params.estado && charter && (
            <FichaReserva
              producto={producto}
              charter={charter}
              pasajerosAdultos={pasajerosAdultos}
              pasajerosPagantes={pasajerosPagantes}
              infoas={infoas}
              pasajerosMenores={pasajerosMenores}
              tarifaNeta={tarifaNeta}
              cargosAdministrativos={cargosAdministrativos}
              impuestos={impuestos}
              totalPaquete={totalPaquete}
              totalPaqueteConPlanFamily={totalPaqueteConPlanFamily}
              puntosDeEmbarques={puntosDeEmbarques}
              totalSeguroCancelacion={totalSeguroCancelacion}
              tarifaPorHabitacion={tarifaPorHabitacion}
            />
          )}
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default ProcesoCompra;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/index.js